module.exports = __webpack_public_path__ + "fce97fff1ca8b8e3b84d659892e05b2c.svg";